import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
// import store from '@/store/index'
Vue.use(Router)

const router = new Router({
    routes
})

/**
 * 路由导航守卫
 */
router.beforeEach((to, from, next) => {
    // store.commit('router/changeMainMenuIndexes', to)
    // NProgress.start()
    document.title = to.name
    next()
})

// router.afterEach(() => {
//     // NProgress.done()
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js